import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { currencyFormat } from 'utils/number';
import { SetStateAction } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export interface IItem {
  pid: string;
  name: string;
  amount: number;
}

interface ItemProps {
  selected: boolean;
  item: IItem;
  setSelect: (val: SetStateAction<IItem[]>) => void;
}

interface ItemWrapperProps {
  selected: boolean;
}

const ItemWrapper = styled.div<ItemWrapperProps>`
  padding: 20px;
  margin: 10px 0px;

  background: #ffffff;
  border: 1px solid #dbe1e6;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  background: ${({ selected }) => selected && '#e9eeff'};
`;

export const Item = ({ item, setSelect, selected }: ItemProps) => {
  const { t } = useTranslation();

  const handdleOnclick = () => {
    setSelect((prev) => {
      const select = prev.includes(item)
        ? prev.filter((data) => data.pid !== item.pid)
        : [...prev, item];

      return select;
    });
  };

  return (
    <ItemWrapper onClick={() => handdleOnclick()} selected={selected}>
      <Grid container>
        <Grid xs={6} item style={{ textAlign: 'left' }}>
          <Typography>{item.name}</Typography>
        </Grid>
        <Grid xs={6} item style={{ textAlign: 'right' }}>
          <Typography>{currencyFormat(item.amount)}</Typography>
        </Grid>
      </Grid>
    </ItemWrapper>
  );
};
